import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Breadcrumb from "../../components/Breadcrumb";
import ScrollToTop from "../../components/ScrollTop";

import DownloadApp from "../home/DownloadApp";
import ZoomQuotationMain from "./ZoomQuotationMain";
import { useLocation } from "react-router";

const Video = () => {
    const location = useLocation();
    const {courseID,courseName } = location.state || {};
  return (
    <>
      <Header parentMenu="course" menuCategoryEnable="enable" />

      <div className="react-wrapper">
        <div className="react-wrapper-inner">
          <Breadcrumb pageTitle="Zoom Quotation" />
          <ZoomQuotationMain courseID={courseID} courseName={courseName}/>
          {/* download-app-start */}
          <DownloadApp />
          {/* download-app-end */}
          {/* scrolltop-start */}
          <ScrollToTop />
          {/* scrolltop-end */}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Video;
